/**
 * BaseButton is not to be used directly.
 * Instead, use one of other button types that implement it.
 */

export const BUTTON_SIZE_MAP = {
	DEFAULT: `input f5 ph4 theme-luxury:h-[40px] theme-luxury:px-4!`,
	SMALL: `input-small f6 ph3 theme-luxury:h-[32px] theme-luxury:px-3!`,
	LARGE: `input-large f4 ph5 theme-luxury:text-base! theme-luxury:h-[56px]`,
	SQUARE: 'text-xl p-1 flex iconbutton',
	CIRCLE: 'f6 pa2 flex br-100 iconbutton',
	ICON: 'input f5 ph3',
	CHECK: 'f3 pa0 iconbutton'
};

export type ButtonSize = keyof typeof BUTTON_SIZE_MAP | null;

const PRIMARY_STYLES =
	'bg-theme-primary theme-white hover-theme-white bn hover-bg-theme-primary-dark active-bg-theme-primary-dark shadow-primary theme-luxury:button-primary! font-medium!';

const SECONDARY_STYLES =
	'font-medium! bn bg-theme-white theme-primary-dark hover-bg-theme-white hover-theme-primary active-theme-primary-darker shadow-secondary theme-luxury:button-secondary!';

const TERTIARY_STYLES =
	'font-medium! bn bg-theme-white theme-primary-dark hover-bg-theme-primary-lighter btn-tertiary theme-luxury:button-tertiary!';

const TERTIARY_GREY_STYLES = 'theme-luxury:button-tertiary-grey!';

const BASE_BUSY = 'o-50 theme-luxury:opacity-100!';
export const BUTTON_STYLE_MAP = {
	PRIMARY: PRIMARY_STYLES,
	PRIMARY_ACCENT: `${PRIMARY_STYLES} shadow-primary-accent active-bg-theme-primary-darker `,
	SECONDARY: SECONDARY_STYLES,
	BUSY_PRIMARY: `${BASE_BUSY} theme-luxury:button-primary-busy!`,
	BUSY_SECONDARY: `${BASE_BUSY} theme-luxury:button-secondary-busy!`,
	BUSY_TERTIARY: `${BASE_BUSY} theme-luxury:button-tertiary-busy!`,
	BUSY_DESTRUCTIVE_PRIMARY: `${BASE_BUSY} theme-luxury:button-primary-busy! destructive`,
	BUSY_DESTRUCTIVE_SECONDARY: `${BASE_BUSY} theme-luxury:button-secondary-busy! destructive`,
	BUSY_DESTRUCTIVE_TERTIARY: `${BASE_BUSY} theme-luxury:button-tertiary-busy! destructive`,
	BUSY_INTERNAL_PRIMARY: `${BASE_BUSY} theme-luxury:button-primary-busy! internal`,
	BUSY_INTERNAL_SECONDARY: `${BASE_BUSY} theme-luxury:button-secondary-busy! internal`,
	BUSY_INTERNAL_TERTIARY: `${BASE_BUSY} theme-luxury:button-tertiary-busy! internal`,
	DANGER: 'font-medium! bw1 bg-theme-white theme-error b--theme-error hover-bg-theme-error hover-theme-white hover-b--theme-error active-b--theme-error active-theme-error theme-luxury:button-secondary! destructive',
	DISABLED: 'o-50 theme-luxury:opacity-100! font-medium bn',

	INTERNAL_ICON: 'bg-theme-white active-bg-theme-white hover-bg-theme-internal-lighter theme-black bn theme-luxury:focus:focus-ring!',
	INTERNAL_SECONDARY:
		'font-medium! bn bg-theme-white theme-internal-dark active-theme-internal-darker shadow-internal-secondary theme-luxury:button-secondary! internal',
	TERTIARY: TERTIARY_STYLES,
	INTERNAL_TERTIARY:
		'font-medium! bn bg-theme-white theme-internal-dark hover-bg-theme-internal-lighter active-bg-theme-internal-light btn-internal-tertiary theme-luxury:button-tertiary! internal',
	// This will replace usages of TextButton. Expectation is that only this and the TERTIARY_GREY buttons will be text only
	TERTIARY_GREY: TERTIARY_GREY_STYLES,
	INTERNAL:
		'font-medium! bn bg-theme-internal theme-internal-lighter hover-bg-theme-internal-dark shadow-internal theme-luxury:button-primary! internal',
	DESTRUCTIVE_PRIMARY: `${PRIMARY_STYLES} destructive`,
	DESTRUCTIVE_SECONDARY: `${SECONDARY_STYLES} destructive`,
	DESTRUCTIVE_TERTIARY: `${TERTIARY_STYLES} destructive`,
	DESTRUCTIVE_TERTIARY_GREY: `${TERTIARY_GREY_STYLES} destructive`,
	GREY: 'font-medium! bg-theme-grey theme-white b--theme-grey hover-bg-theme-grey-darker',
	ICON: 'bg-theme-white theme-grey b--theme-grey-light hover-theme-primary active-theme-primary-darker'
};

export const DISABLED_BUTTON_STYLE_MAP = {
	PRIMARY: 'shadow-primary bg-theme-grey theme-internal-lighter theme-luxury:theme-white theme-luxury:button-primary-disabled!',
	SECONDARY: 'shadow-secondary theme-grey theme-luxury:button-secondary-disabled!',
	TERTIARY: 'shadow-tertiary theme-grey bg-theme-white theme-luxury:button-tertiary-disabled!',
	TERTIARY_GREY: 'theme-luxury:button-tertiary-grey-disabled!'
};

export type ButtonStyle = keyof typeof BUTTON_STYLE_MAP;
